import { useNavigate } from 'react-router-dom'

import { Button } from '../../../components/Button/Button'

export const DocumentProspectingHeader = () => {
  const navigate = useNavigate()

  const handleBackButtonClicked = () => {
    navigate('/library/manage-contacts')
  }

  return (
    <div className='d-flex align-items-center gap-3 zocks-pl-2.0'>
      <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
        <i className='bi bi-chevron-left' />
      </Button>
    </div>
  )
}
